import axiosInstance from "./util/auth_util";

const discountServer = {
    // 新增折扣
    async createCampaign(formData){
        try{
            const response = await axiosInstance.post("/discount/add", formData,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            return response.data;
        }catch(error){
            console.log(error)
        }
    },

    // 修改折扣
    async updateCampaign(payload){
        try{
            const response = await axiosInstance.put("/discount/update", payload,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            return response.data;
        }catch(error){
            console.log(error)
        }
    },

    // 获取折扣
    async getCampaigns(){
        try{
            const response = await axiosInstance.get("/discount")
            return response.data;
        }catch(error){
            console.log(error)
        }
    },

    // 删除商品
    async deleteCampaign(campaignId){
        const response = await axiosInstance.delete(`/discount/delete/${campaignId}`)
        return response.data;
    },
    // 获取当前折扣
    async getCurrentCampaign(){
        try{
            const response = await axiosInstance.get("/discount/current")
            return response.data;
        }catch(error){
            console.log(error)
        }
    }
}

export default discountServer